<template lang="html">
  <boxwrap class="point--inner">
    <toolbar>
      <toolbar-items class="-searchbar">
      </toolbar-items>
    </toolbar>

    <boxwrap-contents :class="{'data-loading': showDataLoading}">
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>
      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
        v-else
      >
        <tbl-inner >
          <tbl-head>
            <tbl-row>
              <tbl-td
                name="actions"
              >
              </tbl-td>
              <tbl-td
                name="point_type"
              >
                point type
              </tbl-td>
              <tbl-td
                v-for="level in 10"
                :key="level"
                :name="`level_${level+1}`"
                class="lvl"
              >
                level {{level}}
              </tbl-td>
              <tbl-td class="actions">

              </tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="type in arranged"
              :key="type.id"
            >
              <tbl-td
                name="actions"
              >
                <checkbox
                  type="toggle"
                  class="toggle--inverted"
                  toggleA="active"
                  toggleB="inactive"
                  @click.native.prevent="toggleEnabled(type)"
                >
                  <input
                    type="checkbox"
                    v-model="type.active"
                  />
                </checkbox>
                <!-- {{type.type_id}} -->
              </tbl-td>
              <tbl-td
                name="point_type"
              >
                {{type.type}}
              </tbl-td>

              <tbl-td
                v-for="(level, x) in type.levels"
                class="lvl"
                :name="`level_${x+1}`"
                :key="x"
              >
                <div
                  class="input-wrap"
                  v-if="modify === type.type_id"
                >
                  <input v-model="level.data.values">
                </div>
                <span v-else>
                  {{ level.data.values | percent}}%
                </span>
              </tbl-td>

              <tbl-td class="actions">
                <button
                  class="btn--default"
                  @click="modify=type.type_id"
                  v-if="modify!==type.type_id"
                >
                  <i class="ico--edit"></i>
                </button>

                <button
                  class="btn--modify"
                  v-if="modify===type.type_id"
                  @click="save(type)"
                >
                  <i class="ico--save"></i>
                </button>
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>
      </tbl>
    </boxwrap-contents>
  </boxwrap>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Checkbox from '@/components/base/Checkbox'
import CheckDataList from '@/components/base/CheckDataList'

//= mixin
import { swal } from '@/assets/js/mixins/base/Swal'
export default {
  name: 'point',

  components: {
    Checkbox,
    CheckDataList
  },

  mixins: [
    swal
  ],

  filters: {
    percent (val) {
      return parseFloat(val) * 100
    }
  },

  data () {
    return {
      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,

      modify: null
    }
  },

  computed: {
    ...mapState('settings-points', ['points', 'arranged'])
  },

  watch: {

  },

  created () {
    this.search()
  },

  methods: {
    ...mapActions('settings-points', ['get', 'update', 'create']),

    toggleEnabled (data) {
      this.$alert('prompt', 'Are you sure you want to proceed ?', {}, { success: async () => {
        data.active = !data.active
        await this.update({ data: data })
      } }, 'Modify')
    },

    async search () {
      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.get()

      // == flags set
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.arranged.length) {
        this.isEmpty = true
      }
    },

    async save (data) {
      for (var x = 0; x < data.levels.length; x++) {
        if (data.levels[x].data.id) {
          data.levels[x].data.active = data.active
          await this.update({ id: data.levels[x].data.id, data: data.levels[x].data })
        } else {
          if (parseFloat(data.levels[x].data.values) > 0) {
            await this.create({
              type_id: data.type_id,
              level_id: data.levels[x].level,
              values: data.levels[x].data.values,
              active: data.active
            })
          }
        }
      }

      this.modify = null
      this.search()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
